import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import { refreshDatablocks } from '../../expositions/store';
import {
	bulkDelete,
	constructDatablockList,
	constructDatablockListSuccess,
	deleteDatablock,
	deleteDatablockFail,
	fetchDatablockListFail,
	fetchDatablockListSuccess,
	persistDatablockStarted,
	persistDatablockStopped,
	persistenceActionFinish,
	repersistDatablockStarted,
	repersistDatablockStopped,
	trackAction,
	unpersistDatablockStarted,
	unpersistDatablockStopped,
	updateIncludePublic,
} from './datablock.actions';
import { DatablockOriginalSliceState } from './datablock.state';

export const datablockOriginalReducer =
	createReducer<DatablockOriginalSliceState>(
		new DatablockOriginalSliceState(),
		on(goToProjects, setProject, (state) => state.clear()),
		on(constructDatablockList, refreshDatablocks, (state) =>
			state.setLoading(true)
		),
		on(fetchDatablockListFail, (state) => state.setLoading(false)),
		on(constructDatablockListSuccess, (state, action) =>
			state.setDatablockList(action.datablockList)
		),
		on(fetchDatablockListSuccess, (state, action) =>
			state.setLoading(false).setDatablockList(action.datablockList)
		),
		on(updateIncludePublic, (state, action) =>
			state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
		),
		on(deleteDatablock, bulkDelete, (state) => state.setLoading(true)),
		on(deleteDatablockFail, (state) => state.setLoading(false)),
		on(
			persistDatablockStarted,
			repersistDatablockStarted,
			unpersistDatablockStarted,
			(state, action) =>
				state.setDatablockList(
					state.list.setActionInProgress(action.datablockId, true, action.jobId)
				)
		),
		on(
			persistDatablockStopped,
			repersistDatablockStopped,
			unpersistDatablockStopped,
			(state, action) =>
				state.setDatablockList(
					state.list.setActionInProgress(
						action.datablockId,
						false,
						action.jobId
					)
				)
		),
		on(persistenceActionFinish, (state, action) =>
			state.setDatablockList(
				state.list
					.updatePersistenceInfo(action.datablockId, action.persistenceInfo)
					.setJobId(action.datablockId, null)
			)
		),
		on(trackAction, (state, action) =>
			state.setDatablockList(
				state.list.setJobId(action.datablockId, action.jobId)
			)
		)
	);
